import { Flex as ChakraFlex } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type FlexProps = ComponentPropsWithRef<typeof ChakraFlex>;

export function Flex(props: FlexProps) {
  return <ChakraFlex {...props} />;
}
